const img = require('./DecorationXTrim.svg'); export default img;